import React from 'react';
import { OpenConversationIcon } from '../../icon';
import EmptyConvIcon from '../../icons/conversation-view-icon.svg'
interface Props {

}

const BlankConvHistory = (props: Props) => {
    return (
        <div className="d-flex w-fill justify-center h-p-100 align-center">
            <div className="my-auto">
                <img src={EmptyConvIcon} alt="Empty conversation Icon" className='mx-auto d-flex' />
                {/* <OpenConversationIcon /> */}
                <p className='t-align-center h2-regular'>Click on a Conversation to see messages</p>
            </div>
        </div>
    )
}

export default BlankConvHistory